import React from 'react';

type Props = {
  value: number;
  index: number;
} & React.HTMLProps<HTMLDivElement>;

export const TabPanel: React.FC<Props> = props => {
  const { children, value, index, ...rest } = props;

  return (
    <div role="tabpanel" hidden={value !== index} {...rest}>
      {value === index && <div className="py-20">{children}</div>}
    </div>
  );
};
